import { baseReducerState, BaseReducerState, baseState, BaseState } from "Store/Shared/Store/PropTypes";

export type ContactModuleId = string;

export interface ContactModuleState extends BaseState {
    byEntityId: {},
    byEntityIdByType: {}
}

export const initialContactModuleState: ContactModuleState = {
    ...baseState,
    byEntityId: {},
    byEntityIdByType: {}
}